import React, { Fragment, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Routes from "./components/routing/Routes";

//import './App.css';

// Redux
import { Provider } from "react-redux";
import store from "./store";
import { loadUser } from "./actions/auth";
import setAuthToken from "./utils/setAuthToken";


//<h1>Hello world</h1>
if (localStorage.token) {
  setAuthToken(localStorage.token);
}
const App = () => {
  useEffect(() => {
    if (localStorage.UserRole == "ADMIN") {
      store.dispatch(loadUser()).then((e) => {
        localStorage.setItem("Role_user_Auth", e.payload.role);
        localStorage.setItem("User_specific_id", e?.payload?._id);
      });
      //store.dispatch(loadSubUser());
    }
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <Fragment>
          {/* <div id="wrapper"> */}
          <Route component={Routes} />
          {/* </div>       */}
        </Fragment>
      </Router>
    </Provider>
  );
};
export default App;
